'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Banner = require('./Banner.scss');

var _Banner2 = _interopRequireDefault(_Banner);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _gallery = require('redux/modules/gallery');

var _trip = require('redux/modules/trip');

var _WishlistButton = require('components/General/Buttons/WishlistButton');

var _WishlistButton2 = _interopRequireDefault(_WishlistButton);

var _media = require('utils/media');

var _helpers = require('utils/helpers');

var _price = require('utils/price');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Banner: {
    displayName: 'Banner'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Banner.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Banner = _wrapComponent('Banner')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
    // omitBookingFee: state.info.userConfig.omitBookingFee,
    siteConfigs: state.info.siteConfigs
  };
}, { openAndGoTo: _gallery.openAndGoTo, openShare: _trip.openShare }), _dec2 = (0, _reactCssModules2.default)(_Banner2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Banner, _Component);

  function Banner(props) {
    (0, _classCallCheck3.default)(this, Banner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Banner.__proto__ || (0, _getPrototypeOf2.default)(Banner)).call(this, props));

    _this.getQuantity = function () {
      var _this$props = _this.props,
          trip = _this$props.trip,
          sessionData = _this$props.sessionData;

      if (trip.is_per_day !== true) {
        return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
      }
      return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
    };

    _this.renderSalePrice = _this.renderSalePrice.bind(_this);

    if (!(typeof _this.renderSalePrice === 'function')) {
      throw new TypeError('Value of "this.renderSalePrice" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderSalePrice));
    }

    _this.renderBasePrice = _this.renderBasePrice.bind(_this);

    if (!(typeof _this.renderBasePrice === 'function')) {
      throw new TypeError('Value of "this.renderBasePrice" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderBasePrice));
    }

    _this.openCoverImage = _this.openCoverImage.bind(_this);

    if (!(typeof _this.openCoverImage === 'function')) {
      throw new TypeError('Value of "this.openCoverImage" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openCoverImage));
    }

    _this.openShare = _this.openShare.bind(_this);

    if (!(typeof _this.openShare === 'function')) {
      throw new TypeError('Value of "this.openShare" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.openShare));
    }

    return _this;
  }

  (0, _createClass3.default)(Banner, [{
    key: 'openShare',
    value: function openShare(e) {
      e.preventDefault();
      e.stopPropagation();
      this.props.openShare();
    }
  }, {
    key: 'openCoverImage',
    value: function openCoverImage() {
      var trip = this.props.trip;

      var coverIndex = 0;
      if (_lodash2.default.findIndex(trip.images, { image: trip.cover_image }) >= 0 && !trip.video_url) {
        coverIndex = _lodash2.default.findIndex(trip.images, { image: trip.cover_image });
      }
      this.props.openAndGoTo(coverIndex);
    }
  }, {
    key: 'renderSalePrice',
    value: function renderSalePrice() {
      var currency = this.props.sessionData.currency;
      var _props = this.props,
          trip = _props.trip,
          rates = _props.rates,
          siteConfigs = _props.siteConfigs;

      var quantity = this.getQuantity();
      var isUsedForeignPrices = trip.foreign_full_prices !== undefined && trip.foreign_full_prices[currency] !== undefined;
      var prices = isUsedForeignPrices ? trip.foreign_full_prices[currency] : trip.full_prices;
      var displayPrice = (0, _helpers.getDisplayPrice)(quantity, prices, true);
      displayPrice = isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates);
      return _react3.default.createElement(
        'span',
        { styleName: 'mobile-sale-price' },
        (0, _helpers.commaizeInt)((0, _price.ceil)(isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates), currency, rates, !isUsedForeignPrices)),
        ' ',
        siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency,
        '/',
        trip.is_per_day === true ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.day' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.person' })
      );
    }
  }, {
    key: 'renderBasePrice',
    value: function renderBasePrice() {
      var currency = this.props.sessionData.currency;
      var _props2 = this.props,
          trip = _props2.trip,
          rates = _props2.rates,
          siteConfigs = _props2.siteConfigs;

      var quantity = this.getQuantity();
      var isUsedForeignPrices = trip.foreign_full_prices !== undefined && trip.foreign_full_prices[currency] !== undefined;
      var prices = isUsedForeignPrices ? trip.foreign_full_prices[currency] : trip.full_prices;
      var displayPrice = (0, _helpers.getDisplayPrice)(quantity, prices, true);
      displayPrice = isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates);
      var displaySeasonedPrice = (0, _helpers.getDisplaySeasonedPrice)(quantity, prices, true);
      if (trip.discount_percentage > 0) {
        return _react3.default.createElement(
          'span',
          { styleName: 'mobile-cross-price' },
          (0, _helpers.commaizeInt)((0, _price.ceil)(isUsedForeignPrices ? displaySeasonedPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displaySeasonedPrice, rates), currency, rates, !isUsedForeignPrices)),
          ' ',
          siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          trip = _props3.trip,
          isWishlisted = _props3.isWishlisted;
      // const {currency, quantity} = this.props.sessionData;

      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
      return _react3.default.createElement(
        'div',
        { styleName: 'cover-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'cover-left' },
          _react3.default.createElement('div', { styleName: 'cover-shadow-filter' }),
          _react3.default.createElement('div', {
            styleName: 'cover-blur',
            style: { backgroundImage: 'url(' + (0, _media.path)(trip.cover_image, 'tripCover') + ')' }
          })
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'cover-right' },
          _react3.default.createElement('div', { styleName: 'cover-shadow-filter' }),
          _react3.default.createElement('div', {
            styleName: 'cover-blur',
            style: { backgroundImage: 'url(' + (0, _media.path)(trip.cover_image, 'tripCover') + ')' }
          })
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'cover-inner', onClick: this.openCoverImage },
          _react3.default.createElement(
            'div',
            { styleName: 'cover-aspect-ratio' },
            _react3.default.createElement('img', {
              src: (0, _media.path)(trip.cover_image, 'tripCover'),
              alt: trip.name,
              styleName: 'cover-picture-img'
            }),
            trip.video_url && _react3.default.createElement('div', { styleName: 'play-banner' }),
            trip.product_type !== 'ticket' && _react3.default.createElement(
              'div',
              { styleName: 'cover-shadow' },
              _react3.default.createElement(
                'div',
                { styleName: 'mobile-price-container' },
                trip.discount_percentage > 0 && _react3.default.createElement(
                  'div',
                  { styleName: 'mobile-discount' },
                  _react3.default.createElement(
                    'p',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'trip.item.discount',
                      values: {
                        percent: trip.discount_percentage * 100 + '%',
                        lineBreak: _react3.default.createElement('br', null)
                      }
                    })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'mobile-price' },
                  _react3.default.createElement(
                    'span',
                    { styleName: 'mobile-best-price' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.best_price_guaranteed' })
                  ),
                  this.renderSalePrice(),
                  this.renderBasePrice()
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'mobile-share' },
                  _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement('a', { styleName: 'share-button', onClick: this.openShare })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'mobile-wishlist' },
                  _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(_WishlistButton2.default, { label: true, active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Banner;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  // omitBookingFee: PropTypes.bool,
  rates: _react2.PropTypes.object,
  isWishlisted: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object,
  openAndGoTo: _react2.PropTypes.func,
  openShare: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = Banner;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Banner.js
// module id = 1628
// module chunks = 0